package components

import it.neckar.react.common.*
import kotlinx.browser.window
import kotlinx.html.js.onClickFunction
import react.*
import react.dom.*
import react.router.useLocation
import store.StaleDataWarningThreshold
import store.staleDataTracker
import kotlin.time.Duration.Companion.seconds

/**
 * How often the [staleDataTracker] is asked whether the data is stale
 */
private val staleCheckInterval = 30.seconds

/**
 * Reproduces the wrappers of the page content in `MainStage`, so the banner text starts on the same line.
 */
private val StaleDataBannerContentWrapperClasses: List<String> = listOf("banner-page-gutter", "col-sm-12 main-content", "container")

/**
 * Warns that the displayed data may be outdated. The banner stays until the page is reloaded.
 */
val StaleDataBanner: FC<Props> = fc("StaleDataBanner") {
  val location = useLocation()
  val (isStale, setIsStale) = useState(false)

  useEffect(location.pathname, location.search) {
    staleDataTracker.markActivity()
  }

  useEffectOnceWithCleanup {
    val intervalId = window.setInterval({ setIsStale(staleDataTracker.isStale()) }, staleCheckInterval.inWholeMilliseconds.toInt())
    onCleanup {
      window.clearInterval(intervalId)
    }
  }

  if (isStale) {
    notificationBanner("Daten möglicherweise veraltet", BannerType.Warning, BannerPlacement.Bottom, contentWrapperClasses = StaleDataBannerContentWrapperClasses) {
      p {
        +"Die Seite ist seit ${StaleDataWarningThreshold.inWholeMinutes} Minuten unverändert. Bitte laden Sie die Seite neu, damit Sie keine Änderungen eines anderen Users überschreiben."
      }
      button(classes = "btn btn-warning btn-sm") {
        attrs {
          onClickFunction = { window.location.reload() }
        }
        +"Seite neu laden"
      }
    }
  }
}
